<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="MonthWIPCostEx"
                :filter_language="['dead_cost_clear_flag']"
                :filter_thousandth="['std_manhour','actually_manhour','material_cost','man_cost','charge_cost','charge_material_cost','carry_man_cost','carry_charge_cost',
                'nobalance_material_cost','nobalance_man_cost','nobalance_charge_cost','nobalance_charge_material_cost','carry_nobalance_man_cost','carry_nobalance_charge_cost',
                'nobalance_mancharge','close_material_cost','close_man_cost','close_charge_cost','close_charge_material_cost','close_carry_man_cost','close_carry_charge_cost',
                'month_unit_material','month_unit_man','month_unit_charge','month_unit_charge_material','month_unit_carry_man','month_unit_carry_charge','plan_finish_qty']"
                :header="tableHeader"
                :option="tableOption"
                ref="singleTable"
                :checkflg="false"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                :cell-class-name="rowClass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cost_year" :label="$t('getapi[1974]')" fixed align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cost_month" :label="$t('getapi[1975]')" fixed align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')" fixed></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_code" :label="$t('getapi[4361]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[882]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="std_manhour" :label="$t('getapi[7484]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="actually_manhour" :label="$t('getapi[7485]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="finish_qty" :label="$t('getapi[4883]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="material_cost" :label="$t('getapi[7486]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="man_cost" :label="$t('getapi[7487]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="charge_cost" :label="$t('getapi[7488]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="charge_material_cost" :label="$t('getapi[7489]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="carry_man_cost" :label="$t('getapi[7490]')" width="140" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="carry_charge_cost" :label="$t('getapi[7491]')" width="140" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="nobalance_material_cost" :label="$t('getapi[7492]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="nobalance_man_cost" :label="$t('getapi[7493]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="nobalance_charge_cost" :label="$t('getapi[7494]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="nobalance_charge_material_cost" :label="$t('getapi[7495]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="carry_nobalance_man_cost" :label="$t('getapi[7496]')" width="140" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="carry_nobalance_charge_cost" :label="$t('getapi[7497]')" width="140" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="nobalance_mancharge" :label="$t('getapi[7498]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_material_cost" :label="$t('getapi[7499]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_man_cost" :label="$t('getapi[7500]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_charge_cost" :label="$t('getapi[7501]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_charge_material_cost" :label="$t('getapi[7502]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_carry_man_cost" :label="$t('getapi[7503]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_carry_charge_cost" :label="$t('getapi[7504]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="month_unit_material" :label="$t('getapi[7505]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="month_unit_man" :label="$t('getapi[7506]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="month_unit_charge" :label="$t('getapi[7507]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="month_unit_charge_material" :label="$t('getapi[7508]')" width="120" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="month_unit_carry_man" :label="$t('getapi[7509]')" width="140" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="month_unit_carry_charge" :label="$t('getapi[7510]')" width="140" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="calc_flag" :label="$t('getapi[7511]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="data_flag" :label="$t('getapi[7512]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="dead_cost_clear_flag" :label="$t('getapi[7513]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="plan_finish_qty" :label="$t('getapi[4516]')" align="right"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="MonthWIPCostEx" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6667]')" queryData="MonthWIPCostEx" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_wipcost',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_wipcost'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('MonthWIPCostEx',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            rowClass({ row, column, rowIndex, columnIndex }){
                if(columnIndex == 12 || columnIndex == 13 || columnIndex == 14 || columnIndex == 15 || columnIndex == 16 || columnIndex == 17){
                    return 'yellow'
                } else if(columnIndex == 18 || columnIndex == 19 || columnIndex == 20 || columnIndex == 21 || columnIndex == 22 || columnIndex == 23 || columnIndex == 24){
                    return 'green'
                } else if(columnIndex == 31 || columnIndex == 32 || columnIndex == 33 || columnIndex == 34 || columnIndex == 35 || columnIndex == 36){
                    return 'purple'
                }
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6667]"),this.$t("getapi[6633]"));
            },
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_wipcost',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'MonthWIPCostEx');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Fin/Wip/GetWipCostView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true
                that.$refs.SetBtn.SetOneBtnEnable('export', false);
                that.$http.urlpost('/Fin/Wip/GetWipCostViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        that.loading = false
                        that.$refs.SetBtn.SetOneBtnEnable('export', true);
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "MonthWIPCostEx",
                    fromname: that.$t('getapi[6667]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.yellow{
        background:#fff7bf
    }
    /deep/.green{
        background: #c4ffaf
    }
    /deep/.purple{
        background: #edc6ff
    }
</style>
